module.exports = __webpack_public_path__ + "img/mutasi.3147d5c3.svg";